import { render } from "./Ingredients-edit.vue?vue&type=template&id=036978b0&scoped=true"
import script from "./Ingredients-edit.vue?vue&type=script&lang=js"
export * from "./Ingredients-edit.vue?vue&type=script&lang=js"

import "./Ingredients-edit.vue?vue&type=style&index=0&id=036978b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036978b0"]])

export default __exports__